import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await axios.post(
                `${API}/auth/login`,
                { email, password },
                { withCredentials: true }
            );
            if (data?.token) {
                localStorage.setItem("ur_admin_token", data.token);
            }
            toast.success("Welcome back, Coach.");
            nav("/admin");
        } catch (err) {
            const detail = err.response?.data?.detail;
            const msg = typeof detail === "string" ? detail : "Login failed";
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-ink text-white flex items-center justify-center px-6">
            <form
                onSubmit={submit}
                data-testid="admin-login-form"
                className="w-full max-w-md border border-white/10 bg-inksurface p-10"
            >
                <div className="text-xs font-mono uppercase tracking-[0.3em] text-volt">— Staff Only</div>
                <h1 className="font-display font-black uppercase text-4xl mt-3">Admin Login</h1>
                <p className="text-zinc-400 text-sm mt-3">Access the Urban Rookies coaching back-office.</p>
                <input
                    data-testid="admin-email"
                    type="email"
                    required
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full mt-8 bg-ink border border-white/10 px-4 py-3 text-white placeholder:text-zinc-500 focus:border-volt outline-none"
                />
                <input
                    data-testid="admin-password"
                    type="password"
                    required
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full mt-3 bg-ink border border-white/10 px-4 py-3 text-white placeholder:text-zinc-500 focus:border-volt outline-none"
                />
                <button
                    data-testid="admin-login-btn"
                    disabled={loading}
                    className="btn-volt w-full mt-6 px-8 py-4 text-xs inline-flex items-center justify-center gap-3 disabled:opacity-60"
                >
                    {loading ? <Loader2 className="animate-spin" size={16} /> : null}
                    Sign In →
                </button>
            </form>
        </div>
    );
}
